import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { isAdministratorGuard } from './guards/is-administrator.guard';
import { isPlannerGuard } from './guards/is-planner.guard';
import { isSuperuserOrAdministratorGuard } from './guards/is-superuser-or-administrator.guard';

export const pmtRoutes: Routes = [
  {
    path: 'auth-callback',
    loadComponent: () =>
      import('./components/auth-callback/auth-callback.component').then(
        m => m.AuthCallbackComponent
      )
  },
  {
    path: 'notifications',
    canActivate: [authGuard],
    loadChildren: () =>
      import('./modules/notifications/notifications.routes').then(
        m => m.NOTIFICATIONS_ROUTES
      )
  },
  {
    path: 'workflow',
    data: {
      title: 'Workflow'
    },
    canActivate: [authGuard],
    children: [
      {
        path: 'work-items-overview',
        data: {
          title: 'Overview',
          parent: 'workflow',
          parentName: 'Workflow'
        },
        loadChildren: () =>
          import('./modules/work-items-overview/work-items-overview.routes').then(
            m => m.WORK_ITEMS_OVERVIEW_ROUTES
          )
      },
      {
        path: 'work-items',
        data: {
          title: 'Work items',
          parent: 'workflow',
          parentName: 'Workflow'
        },
        loadChildren: () =>
          import('./modules/work-items-micro/work-items-micro.routes').then(
            m => m.WORK_ITEMS_MICRO_ROUTES
          )
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'work-items'
      }
    ]
  },
  {
    path: 'client-overview',
    data: {
      title: 'Client overview'
    },
    canActivate: [authGuard],
    loadChildren: () =>
      import('./modules/client-overview/client-overview.routes').then(
        m => m.CLIENT_OVERVIEW_ROUTES
      )
  },
  {
    path: 'reports',
    data: {
      title: 'Reports'
    },
    canActivate: [authGuard],
    children: [
      {
        path: 'charts',
        data: {
          title: 'Charts',
          parent: 'reports',
          parentName: 'Reports'
        },
        loadChildren: () =>
          import('./modules/report-charts/report-charts.routes').then(
            m => m.REPORT_CHARTS_ROUTES
          )
      },
      {
        path: 'checklists',
        data: {
          title: 'Checklist details',
          parent: 'reports',
          parentName: 'Reports'
        },
        loadChildren: () =>
          import('./modules/report-checklists/report-checklists.routes').then(
            m => m.REPORT_CHECKLISTS_ROUTES
          )
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'charts'
      }
    ]
  },
  {
    path: 'setup',
    data: {
      title: 'Setup'
    },
    canActivate: [authGuard],
    canActivateChild: [isAdministratorGuard],
    children: [
      {
        path: 'processes',
        data: {
          title: 'Process',
          parent: 'setup',
          parentName: 'Setup'
        },
        loadChildren: () =>
          import('./modules/process-setup/process-setup.routes').then(
            m => m.PROCESS_SETUP_ROUTES
          )
      },
      {
        path: 'qaprocesses',
        data: {
          title: 'QA Process',
          parent: 'setup',
          parentName: 'Setup'
        },
        loadChildren: () =>
          import('./modules/process-setup/process-setup.routes').then(
            m => m.PROCESS_SETUP_ROUTES
          )
      },
      {
        path: 'validationrules',
        data: {
          title: 'Validation rule',
          parent: 'setup',
          parentName: 'Setup'
        },
        loadChildren: () =>
          import('./modules/validation-rules/validation-rules.routes').then(
            m => m.VALIDATION_RULES_ROUTES
          )
      },
      {
        path: 'fields',
        data: {
          title: 'Information fields',
          parent: 'setup',
          parentName: 'Setup'
        },
        loadChildren: () =>
          import('./modules/information-fields/information-fields.routes').then(
            m => m.INFORMATION_FIELDS_ROUTES
          )
      },
      {
        path: 'headers',
        data: {
          title: 'Field headers',
          parent: 'setup',
          parentName: 'Setup'
        },
        loadChildren: () =>
          import('./modules/field-headers/field-headers.routes').then(
            m => m.FIELD_HEADERS_ROUTES
          )
      },
      {
        path: 'checklist',
        data: {
          title: 'Checklist',
          parent: 'setup',
          parentName: 'Setup'
        },
        loadChildren: () =>
          import('./modules/checklist-setup/checklist-setup.routes').then(
            m => m.CHECKLIST_SETUP_ROUTES
          )
      },
      {
        path: 'checklists',
        data: {
          title: 'Checklist (NEW)',
          parent: 'setup',
          parentName: 'Setup'
        },
        loadChildren: () =>
          import('./modules/checklist-setup-micro/checklist-setup-micro.routes').then(
            m => m.CHECKLIST_SETUP_MICRO_ROUTES
          )
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'processes'
      }
    ]
  },
  {
    path: 'manager',
    data: {
      title: 'Manager'
    },
    canActivate: [authGuard],
    canActivateChild: [isAdministratorGuard],
    children: [
      {
        path: 'users',
        data: {
          title: 'User accesses',
          parent: 'manager',
          parentName: 'Manager'
        },
        loadChildren: () =>
          import('./modules/users/users.routes').then(m => m.USERS_ROUTES)
      },
      {
        path: 'task-builder',
        data: {
          title: 'Task builder',
          parent: 'manager',
          parentName: 'Manager'
        },
        loadChildren: () =>
          import('./modules/task-builder/task-builder.routes').then(
            m => m.TASK_BUILDER_ROUTES
          )
      },
      {
        path: 'settings',
        data: {
          title: 'Settings',
          parent: 'manager',
          parentName: 'Manager'
        },
        loadChildren: () =>
          import('./modules/settings/settings.routes').then(
            m => m.SETTINGS_ROUTES
          )
      },
      {
        path: 'feedbacks',
        data: {
          title: 'Feedbacks',
          parent: 'manager',
          parentName: 'Manager',
          hideProduction: true,
          hideStage: true
        },
        loadChildren: () =>
          import('./modules/feedback/feedback.routes').then(
            m => m.FEEDBACK_ROUTES
          )
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'users'
      }
    ]
  },
  {
    path: 'log',
    data: {
      title: 'Logs'
    },
    canActivate: [authGuard],
    canActivateChild: [isSuperuserOrAdministratorGuard],
    children: [
      {
        path: 'logs',
        data: {
          title: 'Logs',
          parent: 'log'
        },
        loadChildren: () =>
          import('./modules/logs/logs.routes').then(m => m.LOGS_ROUTES)
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'logs'
      }
    ]
  },
  {
    path: 'planner',
    data: {
      title: 'Planner'
    },
    canActivate: [authGuard],
    canActivateChild: [isPlannerGuard],
    children: [
      {
        path: 'planner-scheduler',
        data: {
          title: 'Scheduler',
          parent: 'planner',
          parentName: 'Planner'
        },
        loadChildren: () =>
          import('./modules/planner-scheduler/planner-scheduler.routes').then(
            m => m.PLANNER_SCHEDULER_ROUTES
          )
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'planner-scheduler'
      }
    ]
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'workflow'
  },
  {
    path: '**',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./components/not-found/not-found.component').then(
        m => m.NotFoundComponent
      )
  }
];
